
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workspace-management/audit-logs",
      function () {
        return require("private-next-pages/workspace-management/audit-logs.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/workspace-management/audit-logs"])
      });
    }
  